<template>
  <div>
    <el-form-item label="请求URL" prop="content.url">
      <el-input v-model="modelValue.url" placeholder="请输入请求URL" />
    </el-form-item>

    <el-form-item label="请求方法" prop="content.method">
      <el-select v-model="modelValue.method" placeholder="请选择请求方法">
        <el-option label="GET" value="GET" />
        <el-option label="POST" value="POST" />
      </el-select>
    </el-form-item>

    <el-form-item label="请求头">
      <div v-for="(value, key) in modelValue.headers" :key="'header-'+key" class="key-value-item">
        <el-input v-model="modelValue.headers[key]" placeholder="请输入值">
          <template #prepend>{{ key }}</template>
        </el-input>
        <el-button type="danger" @click="removeHeader(key)">删除</el-button>
      </div>
      <div class="add-key-value">
        <el-input v-model="newHeaderKey" placeholder="键名" style="width: 120px" />
        <el-input v-model="newHeaderValue" placeholder="值" style="width: 120px" />
        <el-button type="primary" @click="addHeader">添加请求头</el-button>
      </div>
    </el-form-item>

    <el-form-item label="请求体">
      <div v-for="(value, key) in modelValue.body" :key="'body-'+key" class="key-value-item">
        <el-input v-model="modelValue.body[key]" placeholder="请输入值">
          <template #prepend>{{ key }}</template>
        </el-input>
        <el-button type="danger" @click="removeBody(key)">删除</el-button>
      </div>
      <div class="add-key-value">
        <el-input v-model="newBodyKey" placeholder="键名" style="width: 120px" />
        <el-input v-model="newBodyValue" placeholder="值" style="width: 120px" />
        <el-button type="primary" @click="addBody">添加请求体</el-button>
      </div>
    </el-form-item>

    <el-form-item label="钉钉Webhook" prop="content.webHookUrl">
      <el-input v-model="modelValue.webHookUrl" placeholder="请输入钉钉机器人Webhook地址" />
    </el-form-item>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const newHeaderKey = ref('')
    const newHeaderValue = ref('')
    const newBodyKey = ref('')
    const newBodyValue = ref('')

    const addHeader = () => {
      if (newHeaderKey.value) {
        emit('update:modelValue', {
          ...props.modelValue,
          headers: {
            ...props.modelValue.headers,
            [newHeaderKey.value]: newHeaderValue.value || ''
          }
        })
        newHeaderKey.value = ''
        newHeaderValue.value = ''
      }
    }

    const removeHeader = (key) => {
      const newHeaders = { ...props.modelValue.headers }
      delete newHeaders[key]
      emit('update:modelValue', {
        ...props.modelValue,
        headers: newHeaders
      })
    }

    const addBody = () => {
      if (newBodyKey.value) {
        emit('update:modelValue', {
          ...props.modelValue,
          body: {
            ...props.modelValue.body,
            [newBodyKey.value]: newBodyValue.value || ''
          }
        })
        newBodyKey.value = ''
        newBodyValue.value = ''
      }
    }

    const removeBody = (key) => {
      const newBody = { ...props.modelValue.body }
      delete newBody[key]
      emit('update:modelValue', {
        ...props.modelValue,
        body: newBody
      })
    }

    return {
      newHeaderKey,
      newHeaderValue,
      newBodyKey,
      newBodyValue,
      addHeader,
      removeHeader,
      addBody,
      removeBody
    }
  }
}
</script>

<style scoped>
.key-value-item {
  display: flex;
  margin-bottom: 10px;
}
.key-value-item .el-input {
  margin-right: 10px;
}
.add-key-value {
  display: flex;
  gap: 10px;
}
</style>
